import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import VotesCheckbox from './votes_checkbox'
import CastVotesHeader from './cast_votes_header'
import SubmitVoteButton from './submit_vote_button'
import VotesTable from './votes_table'
import VOTE_LABELS from './vote_labels'

export default class VotesContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vote_value: this.props.stage_data.vote_value,
      vote_date: this.props.stage_data.vote_date,
      address: this.props.stage_data.address,
      unit: this.props.stage_data.unit,
      completed: this.props.stage_data.vote_value !== "",
      selectedOption: "",
      showConfirmModal: false,
      showNextStepsModal: false,
    }
    this.confirmModalRef   = React.createRef();
    this.nextStepsModalRef = React.createRef();
    this._triggerEl        = null;
    this.handleUpdateSelectedOption = this.handleUpdateSelectedOption.bind(this);
    this.handleSave    = this.handleSave.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleTabKey  = this.handleTabKey.bind(this);
  }

  handleUpdateSelectedOption(option) {
    let newOption = option == this.state.selectedOption ? "" : option;
    this.setState({selectedOption: newOption})
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showConfirmModal && !prevState.showConfirmModal) {
      this.confirmModalRef.current?.querySelector('button')?.focus();
    }
    if (this.state.showNextStepsModal && !prevState.showNextStepsModal) {
      this.nextStepsModalRef.current?.querySelector('button, a')?.focus();
    }
    if (!this.state.showConfirmModal && prevState.showConfirmModal && !this.state.showNextStepsModal) {
      this._triggerEl?.focus();
      this._triggerEl = null;
    }
    if (!this.state.showNextStepsModal && prevState.showNextStepsModal) {
      this._triggerEl?.focus();
      this._triggerEl = null;
    }
  }

  handleTabKey(e, modalRef) {
    if (e.key !== 'Tab') return;
    const modal = modalRef.current;
    if (!modal) return;
    const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  }

  handleSave() {
    this._triggerEl = document.activeElement;
    this.setState({showConfirmModal: true})
  }

  handleConfirm() {
    const path = this.props.save_path;
    $.ajax({
      url: path,
      method: "post",
      dataType: 'json',
      data: {vote_value: this.state.selectedOption},
      context: this,
      success: (res) => {
        if (res.success) {
          this.setState({
            completed: true,
            vote_value: this.state.selectedOption,
            vote_date: res.vote_date,
            showConfirmModal: false,
            showNextStepsModal: true,
          });
        } else {
          this.setState({showConfirmModal: false});
          swal("Error", res.errors, 'error')
        }
      }
    })
  }

  render() {
    const { address, unit, selectedOption, completed, vote_value, vote_date,
            showConfirmModal, showNextStepsModal } = this.state;
    const { decision_due_at, status_path, decision_closed } = this.props;
    const effectiveCompleted = completed || decision_closed;
    const nextStepsTimelineItems = []
    if (decision_due_at) {
      nextStepsTimelineItems.push({ label: `Decision is due by ${decision_due_at}`, active: true })
    }
    nextStepsTimelineItems.push({ label: 'Remaining board members will cast their votes', active: nextStepsTimelineItems.length === 0 })
    nextStepsTimelineItems.push({ label: 'When the deciding vote is cast, property management will notify the applicant', active: false })

    const checkboxOptions = ["Yes", "No", "Abstain"]
    let checkboxOptionsList = []
    for (let i = 0; i < checkboxOptions.length; i++) {
      let checkboxItem
      const opt = checkboxOptions[i]
      const lbl = VOTE_LABELS[opt]
      if (effectiveCompleted) {
        checkboxItem = <VotesCheckbox key={"option-"+opt} option={opt} label={lbl} checked={vote_value == opt} vote_date={vote_date} />
      } else {
        checkboxItem = <VotesCheckbox key={"option-"+opt} option={opt} label={lbl} checked={opt == selectedOption} handleUpdateSelectedOption={this.handleUpdateSelectedOption} />
      }
      checkboxOptionsList.push(checkboxItem)
    }
    return (
      <div id="vote-container">
        <CastVotesHeader address={address} unit={unit} completed={completed} />
        {decision_closed ? (
          <p className="dome-p2 dome-color-med-grey" style={{marginBottom: 16}}>
            Voting is closed. A final decision has been issued.
          </p>
        ) : (
          <p className="dome-p2 dome-color-med-grey" style={{marginBottom: 16}}>
            Voting will remain open until all votes are in or a decision is reached. Management will then notify the applicant.
          </p>
        )}
        {checkboxOptionsList}
        <SubmitVoteButton submittable={!effectiveCompleted && selectedOption !== ""} handleSave={this.handleSave} />
        {this.props.stage_data.board_members ? <VotesTable boardMembers={this.props.stage_data.board_members} currentUserEmail={this.props.current_user_email} voteValue={vote_value} /> : ""}

        {showConfirmModal && (
          <div className="vote-modal-overlay" onKeyDown={(e) => { if (e.key === 'Escape') this.setState({showConfirmModal: false}) }}>
            <div className="vote-modal dome-d-flex dome-flex-column dome-gap24" ref={this.confirmModalRef} role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title" onKeyDown={(e) => this.handleTabKey(e, this.confirmModalRef)} style={{textAlign: 'left'}}>
              <div className='dome-d-flex dome-flex-column dome-gap12'>
                <i className="fal fa-circle-exclamation" style={{fontSize: 35, color: 'var(--dark-green)'}} />
                <div id="confirm-modal-title" className="dome-h2 dome-color-dark-green">are you sure?</div>
              </div>
              <div className="dome-p1">Your vote will be recorded with today's date.</div>
              <div className="dome-p3 dome-color-med-grey dome-bg-accent dome-rounded-border dome-d-flex dome-align-baseline dome-gap3" style={{padding: '3px'}}>
                <i className="fal fa-circle-info dome-color-aqua dome-p4" />
                <span>Contact management if you need to amend or change your vote.</span>
              </div>
              <div className="vote-modal-actions">
                <button className="dome-btn dome-btn-link dome-btn-link-cancel dome-btn-link-med-grey" onClick={() => this.setState({showConfirmModal: false})}>cancel</button>
                <button className="dome-btn dome-btn-base dome-btn-dark-green" onClick={this.handleConfirm}>confirm vote</button>
              </div>
            </div>
          </div>
        )}

        {showNextStepsModal && (
          <div className="vote-modal-overlay" onKeyDown={(e) => { if (e.key === 'Escape') this.setState({showNextStepsModal: false}) }}>
            <div className="vote-modal dome-d-flex dome-flex-column dome-gap18" ref={this.nextStepsModalRef} role="dialog" aria-modal="true" aria-labelledby="next-steps-modal-title" onKeyDown={(e) => this.handleTabKey(e, this.nextStepsModalRef)} style={{textAlign: 'left'}}>
              <div className='dome-d-flex dome-flex-column dome-gap12'>
                <i className="fat fa-circle-check" style={{fontSize: 45, color: 'var(--dark-green)'}} />
                <div id="next-steps-modal-title" className="dome-h2 dome-color-dark-green">next steps</div>
              </div>
              <div className='dome-d-flex dome-flex-column dome-gap12'>
                <div className="dome-p1">Your vote has been recorded.</div>
                <hr className="dome-hr" style={{margin: 0}} />
                <div className="vote-next-steps-timeline">
                  {nextStepsTimelineItems.map((item, i) => (
                    <div
                      key={i}
                      className={clsx('vote-next-steps-timeline__item', {
                        'vote-next-steps-timeline__item--active': item.active,
                        'vote-next-steps-timeline__item--last': i === nextStepsTimelineItems.length - 1
                      })}
                    >
                      <div className="vote-next-steps-timeline__marker">
                        <span className="vote-next-steps-timeline__dot" />
                        <span className="vote-next-steps-timeline__line" />
                      </div>
                      <div className="vote-next-steps-timeline__label">{item.label}</div>
                    </div>
                  ))}
                </div>
                <hr className="dome-hr" style={{margin: 0}} />
              </div>
              <div className="vote-modal-actions">
                <button className="dome-btn dome-btn-link dome-btn-link-cancel dome-btn-link-med-grey" onClick={() => this.setState({showNextStepsModal: false})}>
                  close
                </button>
                {status_path && (
                  <a className="dome-link dome-is-button dome-link-grey-stroke" href={status_path}>go to status</a>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

VotesContainer.propTypes = {
  stage_data: PropTypes.object.isRequired,
  save_path: PropTypes.string.isRequired,
  current_user_email: PropTypes.string.isRequired,
  decision_due_at: PropTypes.string,
  status_path: PropTypes.string,
  decision_closed: PropTypes.bool,
}
